import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EffectifsWrapperComponent } from './effectifs-wrapper/effectifs-wrapper.component';
import { EffectifsRenderComponent } from './effectifs-render/effectifs-render.component';
import { EffectifsManagerComponent } from './effectifs-manager/effectifs-manager.component';
//import { EffectifsPopoverRenderComponent } from './effectif-popover-render/effectifs-popover-render.component';
import { BodisplayModule } from '../bodisplay';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AvatarSearchModule } from '../avatar-search';
import { ScrollingModule } from '@angular/cdk/scrolling';
//import { PopoverRendererPipe } from './effectif-popover-render/effectifs-popover-render.pipe';
import { AutoSearchModule } from '../autosearch';
import { SearchModule } from '../search';
import { CustomgridModule } from '../customgrid';
//import { EffectifsClientsSurStageWrapperComponent } from './client-sur-stage';
//import { EffectifsClientsSurStagePopoverRenderComponent } from './client-sur-stage/client-sur-stage-popover-render/client-sur-stage-popover-render.component';
//import { EffectifsClientsSurStageManagerComponent } from './client-sur-stage/client-sur-stage-manager/client-sur-stage-manager.component';

@NgModule({

  imports: [
    CommonModule, 
    FormsModule,
    BodisplayModule,
    NgbModule,
    AvatarSearchModule,
    AutoSearchModule,
    ScrollingModule,
    SearchModule,
    CustomgridModule,
  ],
  declarations: [
    EffectifsWrapperComponent,
    EffectifsRenderComponent,
    EffectifsManagerComponent,
    //EffectifsPopoverRenderComponent,
    //PopoverRendererPipe,
    //EffectifsClientsSurStageWrapperComponent,
    //EffectifsClientsSurStagePopoverRenderComponent,
    //EffectifsClientsSurStageManagerComponent,
  ],
  exports: [
    EffectifsWrapperComponent,
    EffectifsRenderComponent,
    //PopoverRendererPipe,
  ]
})

export class EffectifsModule { }
